"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AnswerSchemaByQuestionType () {
        return AnswerSchemaByQuestionType;
    },
    get GoalAnswerModel () {
        return GoalAnswerModel;
    },
    get LegacyGoalDiscussionAnswerModel () {
        return LegacyGoalDiscussionAnswerModel;
    },
    get LegacyReviewReportAnswerModel () {
        return LegacyReviewReportAnswerModel;
    },
    get ReviewReportAnswerModel () {
        return ReviewReportAnswerModel;
    },
    get ReviewReportEasyAddApprovalStatus () {
        return ReviewReportEasyAddApprovalStatus;
    },
    get ReviewReportModel () {
        return ReviewReportModel;
    },
    get ReviewReportSendBackCommentModel () {
        return ReviewReportSendBackCommentModel;
    },
    get ReviewReportSignOffCommentModel () {
        return ReviewReportSignOffCommentModel;
    }
});
const _bson = require("bson");
const _zod = /*#__PURE__*/ _interop_require_default(require("zod"));
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _reviewform = require("./review-form");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const LegacyGoalDiscussionAnswerModel = _zod.default.object({
    goal_id: _zod.default.instanceof(_bson.ObjectId),
    message: _zod.default.string().optional(),
    scale_value: _zod.default.number().optional(),
    selected_option_index: _zod.default.number().optional(),
    score: _zod.default.number().optional(),
    weight: _zod.default.number().optional()
});
const LegacyReviewReportAnswerModel = _zod.default.union([
    _zod.default.array(LegacyGoalDiscussionAnswerModel),
    _zod.default.number(),
    _zod.default.string(),
    _zod.default.array(_zod.default.string())
]);
/**
 * Goal discussion/creation answers.
 */ const BaseReviewReportAnswerGoalModel = _zod.default.object({
    goal_id: _utilsisomorphic.transformObjectId,
    /**
	 * Only included for goal discussion
	 */ message: _zod.default.string().optional()
});
const ScalingReviewReportAnswerGoalDiscussionModel = BaseReviewReportAnswerGoalModel.extend({
    scale_value: _zod.default.number().nullable(),
    selected_option_index: _zod.default.number(),
    weight: _zod.default.union([
        _zod.default.number(),
        _zod.default.literal("")
    ]).optional()
});
const ScoringReviewReportAnswerGoalDiscussionModel = BaseReviewReportAnswerGoalModel.extend({
    score: _zod.default.number().optional(),
    weight: _zod.default.union([
        _zod.default.number(),
        _zod.default.literal("")
    ]).optional()
});
const GoalAnswerModel = _zod.default.union([
    ScalingReviewReportAnswerGoalDiscussionModel,
    ScoringReviewReportAnswerGoalDiscussionModel,
    BaseReviewReportAnswerGoalModel
]);
const ReviewReportAnswerModel = _zod.default.union([
    _zod.default.string(),
    _zod.default.string().array(),
    _zod.default.number(),
    _utilsisomorphic.transformDate,
    GoalAnswerModel.array()
]);
const AnswerSchemaByQuestionType = {
    date: _zod.default.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Invalid date format"),
    numeric: _zod.default.number({
        message: "Answer is not a number"
    }),
    "multiple-choice": _zod.default.string(),
    "multiple-select": _zod.default.array(_zod.default.string()),
    "rating-scale": _zod.default.number().int(),
    "goal-discussion": _zod.default.array(_zod.default.object({
        goal_id: _utilsisomorphic.transformObjectId,
        message: _zod.default.string(),
        score: _zod.default.number().optional(),
        scale_value: _zod.default.number().nullable().optional(),
        selected_option_index: _zod.default.number().optional(),
        weight: _zod.default.union([
            _zod.default.number(),
            _zod.default.string()
        ]).optional()
    })),
    "goal-creation": _zod.default.array(_zod.default.object({
        goal_id: _utilsisomorphic.transformObjectId
    })),
    instructions: _zod.default.literal(""),
    calculator: _zod.default.union([
        _zod.default.number(),
        _zod.default.string()
    ]),
    text: _zod.default.string(),
    multiline: _zod.default.string(),
    stars: _zod.default.number().int().min(0).max(5)
};
const ReviewReportSignOffCommentModel = _zod.default.string();
const ReviewReportSendBackCommentModel = _zod.default.string();
const ReviewReportEasyAddApprovalStatus = _zod.default.enum([
    "pending",
    "approved",
    "declined"
]);
const ReviewReportModel = _zod.default.object({
    // Built-ins
    _id: _utilsisomorphic.transformObjectId,
    company: _utilsisomorphic.transformObjectId,
    review_parent: _utilsisomorphic.transformObjectId,
    subject: _utilsisomorphic.transformObjectId,
    /**
	 * The form this review report is about
	 */ form_id: _utilsisomorphic.transformObjectId,
    /**
	 * The form assignment ID within the template used to generate this review report
	 */ form_assignment_id: _utilsisomorphic.transformObjectId.optional(),
    // Configuration
    authors: _zod.default.array(_utilsisomorphic.transformObjectId.nullable()),
    authors_due_date: _utilsisomorphic.transformDate.optional(),
    easy_add: _zod.default.boolean().optional(),
    external: _zod.default.boolean().optional(),
    redacted: _zod.default.boolean().optional(),
    signers: _zod.default.array(_utilsisomorphic.transformObjectId.nullable()),
    signers_due_date: _utilsisomorphic.transformDate.optional(),
    start_date: _utilsisomorphic.transformDate,
    visible: _zod.default.boolean(),
    // Metadata
    /**
	 * Default 0. Incremented when current author submits
	 */ author_turn: _zod.default.number().optional(),
    /**
	 * Default false. Set to true when the close action is performed
	 */ closed: _zod.default.boolean().optional(),
    complete_date: _utilsisomorphic.transformDate.optional(),
    /**
	 * Default false. Set to true when all author/signer turns are completed
	 */ completed: _zod.default.boolean().optional(),
    /**
	 * Default undefined.
	 */ deleted_at: _utilsisomorphic.transformDate.optional(),
    /**
	 * @deprecated
	 * Default undefined. Used incase any legacy pipelines match on it
	 */ deleted: _zod.default.boolean().optional(),
    /**
	 * Default undefined. Set to "now" when author submits or sent back
	 */ last_author_change: _utilsisomorphic.transformDate.optional(),
    /**
	 * Default undefined. Set to "now" when signer performs sign-off or sent back
	 */ last_signer_change: _utilsisomorphic.transformDate.optional(),
    /**
	 * Default false. Set to true when all signers sign-off (validate current behavior)
	 */ signed: _zod.default.boolean().optional(),
    /**
	 * Default 0 or -1 if no signers. Incremented when current signer performs sign-off (validate current behavior)
	 */ signer_turn: _zod.default.number().optional(),
    /**
	 * Default {}. Updated with { signer_turn: now } when sign-off is performed
	 */ sign_off_dates: _zod.default.record(_utilsisomorphic.numericRecordKey, _utilsisomorphic.transformDate).optional(),
    /**
	 * Default false. Set to true when all authors submit (validate current behavior)
	 */ submit: _zod.default.boolean().optional(),
    /**
	 * Default {}. Updated with { author_turn: now } when submit is performed
	 */ submit_dates: _zod.default.record(_utilsisomorphic.numericRecordKey, _utilsisomorphic.transformDate).optional(),
    // Review report content
    answers: _zod.default.array(ReviewReportAnswerModel).optional(),
    sign_off_comments: _zod.default.record(_utilsisomorphic.numericRecordKey, ReviewReportSignOffCommentModel).optional(),
    // External review report
    external_author: _zod.default.string().optional(),
    external_author_email: _zod.default.string().optional(),
    external_author_invitation: _zod.default.string().optional(),
    invite_sent: _zod.default.boolean().optional(),
    last_invite: _utilsisomorphic.transformDate.optional(),
    token: _zod.default.string().optional(),
    // Easy add
    /**
	 * Only set if approval is required
	 */ approval: _zod.default.object({
        approval_status: ReviewReportEasyAddApprovalStatus,
        approved_at: _utilsisomorphic.transformDate,
        approved_by: _utilsisomorphic.transformObjectId,
        pending_review_report: _utilsisomorphic.transformObjectId
    }).optional(),
    easy_add_data: _zod.default.object({
        allow_comments: _zod.default.boolean().optional(),
        created_by: _utilsisomorphic.transformObjectId,
        easy_add_config: _utilsisomorphic.transformObjectId,
        requiresApproval: _zod.default.preprocess((rawValue)=>{
            // Check for invalid values and default to null
            if (rawValue) {
                if (!_reviewform.ReviewReportRequiresApprovalOptions.includes(rawValue)) {
                    return null;
                }
            }
            return rawValue;
        }, _reviewform.ReviewReportRequiresApprovalModel)
    }).optional(),
    form_comment: _zod.default.string().max(500).optional(),
    // Calculated values
    /**
	 * authors[author_turn] or undefined
	 */ author: _utilsisomorphic.transformObjectId.nullish(),
    /**
	 * The current author/signer due date? (validate current behavior)
	 */ due_date: _utilsisomorphic.transformDate.optional(),
    /**
	 * All unique authors/signers
	 */ participants: _zod.default.array(_utilsisomorphic.transformObjectId.nullable()).optional(),
    /**
	 * The latest value in sign_off_comments
	 */ sign_off_comment: ReviewReportSignOffCommentModel.optional(),
    /**
	 * The latest value in sign_off_dates
	 */ sign_off_date: _utilsisomorphic.transformDate.optional(),
    /**
	 * signers[signer_turn] or undefined
	 */ signer: _utilsisomorphic.transformObjectId.nullish(),
    /**
	 * NEW
	 * Tracks the current state of the review report.
	 * Default: "awaiting-author"
	 *
	 * awaiting-author - The current author has not started authoring.
	 * in-authoring - The current author has started authoring
	 * awaiting-signer - The current signer has not started sign-off
	 * in-sign-off - The current signer has started sign-off
	 * completed - completed = true && closed = false
	 * closed - completed = true && closed = true
	 * deleted - deleted_at exists
	 */ status: _zod.default.enum([
        "awaiting-author",
        "in-authoring",
        "awaiting-signer",
        "in-sign-off",
        "completed",
        "closed",
        "deleted"
    ]).optional(),
    /**
	 * The latest value in submit_dates
	 */ submit_date: _utilsisomorphic.transformDate.optional(),
    // Additional properties that seem safe to ignore
    goals: _zod.default.array(_zod.default.never()).optional(),
    name: _zod.default.string().optional(),
    overdue: _zod.default.boolean().optional(),
    participant_turn: _zod.default.number().optional(),
    sent_back: _zod.default.boolean().optional()
});
